export default __webpack_public_path__ + "static/media/side_bar_bottom.min.d309c285.png";